import * as React from 'react';

/**
 * Rights available in application.
 * 
 * WARNING WARNING: When you add a right here, also add it to resource/Profile.ts,
 * as well as to API:Rights.php !!!
 */
type TRight = 
    'can_view_users' 
  | 'can_edit_users'
  | 'can_delete_users'
  | 'can_view_profiles'
  | 'can_edit_profiles'
  | 'can_delete_profiles'
  | 'can_view_logs'

  | 'can_view_projects'
  | 'can_edit_projects'
  | 'can_delete_projects'
  | 'can_view_campaigns'
  | 'can_edit_campaigns'
  | 'can_delete_campaigns'
  | 'can_view_stations'
  | 'can_edit_stations'
  | 'can_delete_stations'
  | 'can_view_samples'
  | 'can_edit_samples'
  | 'can_delete_samples'
  | 'can_view_parameters'
  | 'can_edit_parameters'
  | 'can_delete_parameters'
  | 'can_view_stationcategories'
  | 'can_edit_stationcategories'
  | 'can_delete_stationcategories'
  | 'can_view_parametercategories'
  | 'can_edit_parametercategories'
  | 'can_delete_parametercategories'
  | 'can_view_results'
  | 'can_edit_results'
  | 'can_delete_results';
  // WARNING WARNING WARNING see above.

interface IRight {
  title: React.ReactNode;
  name: TRight;
}

interface IAccessGroup {
  title: React.ReactNode;
  rights: IRight[];
}

/**
 * These access groups are used in the Profile form.
 */
const ACCESS_GROUPS: IAccessGroup[] = [
  {
    title: "User management",
    rights: [
      { title: "View users", name: 'can_view_users' },
      { title: "Edit users", name: 'can_edit_users' },
      { title: "Delete users", name: 'can_delete_users' },
    ]
  }, {
    title: "Profile management",
    rights: [
      { title: "View profiles", name: 'can_view_profiles' },
      { title: "Edit profiles", name: 'can_edit_profiles' },
      { title: "Delete profiles", name: 'can_delete_profiles' }
    ]
  }, {
    title: "Log management",
    rights: [
      { title: "View logs", name: 'can_view_logs'}
    ]
  }, {
    title: "Project management",
    rights: [
      { title: "View projects", name: 'can_view_projects'},
      { title: "Edit projects", name: 'can_edit_projects' },
      { title: "Delete projects", name: 'can_delete_projects' }
    ]
  }, {
    title: "Campaign management",
    rights: [
      { title: "View campaigns", name: 'can_view_campaigns'},
      { title: "Edit campaigns", name: 'can_edit_campaigns' },
      { title: "Delete campaigns", name: 'can_delete_campaigns' }
    ]
  }, {
    title: "Station management",
    rights: [
      { title: "View stations", name: 'can_view_stations'},
      { title: "Edit stations", name: 'can_edit_stations' },
      { title: "Delete stations", name: 'can_delete_stations' }
    ]
  }, {
    title: "Sample management",
    rights: [
      { title: "View samples", name: 'can_view_samples'},
      { title: "Edit samples", name: 'can_edit_samples' },
      { title: "Delete samples", name: 'can_delete_samples' }
    ]
  }, {
    title: "Parameters management",
    rights: [
      { title: "View parameters", name: 'can_view_parameters'},
      { title: "Edit parameters", name: 'can_edit_parameters' },
      { title: "Delete parameters", name: 'can_delete_parameters' }
    ]
  }, {
    title: "Station category management",
    rights: [
      { title: "View station categories", name: 'can_view_stationcategories'},
      { title: "Edit station categories", name: 'can_edit_stationcategories' },
      { title: "Delete station categories", name: 'can_delete_stationcategories' }
    ]
  }, {
    title: "Parameter category management",
    rights: [
      { title: "View parameter categories", name: 'can_view_parametercategories'},
      { title: "Edit parameter categories", name: 'can_edit_parametercategories' },
      { title: "Delete parameter categories", name: 'can_delete_parametercategories' }
    ]
  }, {
    title: "Result management",
    rights: [
      { title: "View results", name: 'can_view_results'},
      { title: "Edit results", name: 'can_edit_results' },
      { title: "Delete results", name: 'can_delete_results' }
    ]
  }
];


export { TRight, IAccessGroup, IRight, ACCESS_GROUPS };
